import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  Alert,
  Badge,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from "reactstrap";

//import images
import hydroelectricSvg from "../../../assets/images/svg/hydroelectric.svg";
import TableContainer from "Components/Common/TableContainer";
import { numberWithCommas } from "../../../helpers/globalHelper";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useCommonDataFindAllQuery, useHydropowerCreateMutation, useHydropowerDeleteMutation, useHydropowerFindAllQuery, useHydropowerUpdateMutation } from "store";
import DeleteModal from "Components/Common/DeleteModal";
import ShapeUpload from "Components/fileUpload/ShapeUpload";

const Detail = ({ searchField }: any) => {
  const [customQuery, setCustomQuery] = useState<any>();
  const [modal_backdrop, setmodal_backdrop] = useState(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isLoading, setLoading] = useState(true);

  const [hydropowerOne, setHydropowerOne] = useState<any>();
  const [hydropowerList, setHydropowerList] = useState<any>();
  const [hydropowerCount, setHydropowerCount] = useState<any>();

  const [resetFiles, setResetFiles] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<any>([]);

  // Datatable дээр pagination харуулахад хэрэгтэй
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();

  const { data, error, isFetching } = useHydropowerFindAllQuery(customQuery);

  const [hydropowerUpdate, hydropowerUpdateResult] = useHydropowerUpdateMutation();
  const [hydropowerCreate, hydropowerCreateResult] = useHydropowerCreateMutation();
  const [hydropowerDelete, hydropowerDeleteResult] = useHydropowerDeleteMutation();

  const {
    data: commonHydropower,
    error: commonHydropowerError,
    isFetching: isCommonHydropowerFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmn_invesetment_source`);

  useEffect(() => {
    setHydropowerList(data?.data);
    setLoading(false);
    setHydropowerCount(hydropowerList?.length);

    setCustomPagination(data?.pagination);
    const tempQuery = `?page=${customPageLength !== undefined ? customPageLength : 1
      }&pageSize=${customPageSize !== undefined ? customPageSize : 25}&${searchField !== undefined ? searchField : ''}`;
    setCustomQuery(tempQuery);
  }, [data, hydropowerList, customPageSize, customPageLength, customPagination, searchField]);

  const toggle = useCallback(() => {
    if (modal_backdrop) {
      setmodal_backdrop(false);
      setHydropowerOne(null);
    } else {
      setmodal_backdrop(true);
    }
  }, [modal_backdrop]);

  const handleJobClick = useCallback((arg: any) => {
    const hydropowerData = arg;
    setHydropowerOne({
      id: hydropowerData.id,
      code: hydropowerData.code,
      name: hydropowerData.name,
      source_name: hydropowerData.source_name,
      source_part: hydropowerData.source_part,
      budget_cost: hydropowerData.budget_cost,
      cmn_invesetment_source: hydropowerData.cmn_invesetment_source,
      used_date: hydropowerData?.used_date,
      built_organization_description: hydropowerData.built_organization_description,
      location: hydropowerData.location,
    });

    setIsEdit(true);
    toggle();
  }, []);

  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (hydropowerData) => {
    setHydropowerOne(hydropowerData);
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (hydropowerOne) {
      hydropowerDelete(hydropowerOne.id);
      setDeleteModal(false);
    }
  };

  const handleJobClicks = () => {
    setIsEdit(false);
    setHydropowerOne(null);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        header: "№",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Код",
        accessorKey: "code",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Нэр",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Төсвийн эх үүсвэр",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "invesetment_source_name",
      },
      {
        header: "Төсөв",
        accessorKey: "budget_cost",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => {
          return (
            numberWithCommas(cellProps.row.original.budget_cost) + '₮'
          );
        },
      },
      {
        header: "Гүйцэтгэсэн байгууллага",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "built_organization_description",
      },

      {
        header: "Үйлдэл",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li data-bs-toggle="tooltip" data-bs-placement="top" title="View">
                <Link to={`/construction/water/hydroelectric/station/show/${cellProps.row.original.id}`} className="btn btn-sm btn-soft-primary">
                  <i className="mdi mdi-eye-outline" id="viewtooltip"></i>
                </Link>
                <UncontrolledTooltip placement="top" target="viewtooltip">
                  View
                </UncontrolledTooltip>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={(event: any) => {
                    const hydropowerData = cellProps.row.original;
                    event.preventDefault();
                    onClickDelete(hydropowerData);
                  }}
                >
                  <i className="mdi mdi-delete-outline" id="deletetooltip" />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Устгах
                  </UncontrolledTooltip>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-warning"
                  onClick={(event: any) => {
                    const hydropowerData = cellProps.row.original;
                    event.preventDefault();
                    handleJobClick(hydropowerData);
                  }}
                >
                  <i className="mdi mdi-pencil-outline" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Засах
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    []
  );

  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      code: hydropowerOne?.code,
      name: hydropowerOne?.name,
      source_name: hydropowerOne?.source_name,
      source_part: hydropowerOne?.source_part,
      cmn_invesetment_source: hydropowerOne?.cmn_invesetment_source,
      used_date: hydropowerOne?.used_date,
      built_organization_description: hydropowerOne?.built_organization_description,
      budget_cost: hydropowerOne?.budget_cost,
      location: hydropowerOne?.location,
    },
    validationSchema: Yup.object({
      code: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      source_name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      source_part: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      budget_cost: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      cmn_invesetment_source: Yup.string().typeError("Утга сонгоно уу").required("Утга оруулна уу !"),
      used_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
      built_organization_description: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
      location: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      const formData = new FormData();
      if (isEdit) {
        formData.append('id', hydropowerOne ? hydropowerOne.id.toString() : '0');
        formData.append('code', values?.code);
        formData.append('name', values?.name);
        formData.append('source_name', values?.source_name);
        formData.append('source_part', values?.source_part);
        formData.append('cmn_invesetment_source', values?.cmn_invesetment_source);
        formData.append('used_date', values?.used_date);
        formData.append('built_organization_description', values?.built_organization_description);
        formData.append('budget_cost', values?.budget_cost);
        formData.append('location', values?.location);
        hydropowerUpdate(formData)
      } else {
        formData.append('code', values?.code);
        formData.append('name', values?.name);
        formData.append('source_name', values?.source_name);
        formData.append('source_part', values?.source_part);
        formData.append('cmn_invesetment_source', values?.cmn_invesetment_source);
        formData.append('used_date', values?.used_date);
        formData.append('built_organization_description', values?.built_organization_description);
        formData.append('budget_cost', values?.budget_cost);
        formData.append('location', values?.location);

        if (selectedFiles && selectedFiles.length > 0) {
          selectedFiles.forEach((file: File, index: number) => {
            formData.append(`shapes`, file);
          });
        }
        hydropowerCreate(formData)
      }
      validation.resetForm();
      setmodal_backdrop(false)
    },
  });

  return (
    <React.Fragment>
      <DeleteModal
        deleteName={hydropowerOne?.name}
        show={deleteModal}
        onDeleteClick={handleDeletejob}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Col xl={9}>
        <Card>
          <CardBody className="border-bottom">
            <div className="d-flex align-items-center">
              <img src={hydroelectricSvg} alt="" height="50" />
              <div className="flex-grow-1 ms-3">
                <h5 className="fw-semibold">Мэдээлэл</h5>
                <ul className="list-unstyled hstack gap-2 mb-0">
                  <li>
                    <i className="mdi mdi-table-row-height"></i>{" "}
                    <span className="text-muted fw-semibold">
                      Нийт: {numberWithCommas(hydropowerCount)}{" "}
                    </span>
                  </li>
                </ul>
              </div>
              <button
                type="button"
                onClick={() => {
                  toggle();
                }}
                className="btn btn-success  btn-label"
              >
                <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр
                нэмэх
              </button>
            </div>
          </CardBody>

          <CardBody>
            <TableContainer
              setCustomPageSize={setCustomPageSize}
              setCustomPageLength={setCustomPageLength}
              customPagination={customPagination}
              columns={columns}
              data={hydropowerList || ""}
              isCustomPageSize={true}
              isPagination={true}
              colWidth={2}
              SearchPlaceholder="Хэрэглэгч хайх . . ."
              tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
              pagination="pagination"
              paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
            />
          </CardBody>
        </Card>
      </Col>

      <Modal
        size="xl"
        isOpen={modal_backdrop}
        toggle={() => {
          toggle();
        }}
        backdrop={"static"}
        id="staticBackdrop"
        centered
      >
        <ModalHeader
          toggle={() => {
            toggle();
          }}
        >
          <div className="h5 modal-title" id="staticBackdropLabel">
            {!!isEdit ? "Усан цахилгаан станц мэдээлэл засах" : "Усан цахилгаан станц мэдээлэл нэмэх"}
          </div>
        </ModalHeader>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <Alert color="warning" className="mb-3">
              <strong className="text-danger">(*)</strong> тэмдэг бүхий талбарыг {""}
              <Link to="#" className="alert-link">
                заавал бөглөх
              </Link>  шаардлагатайг анхаарна уу !!!
            </Alert>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <Label className="text-danger"> Усан цахилгаан станцын бүртгэлийн дугаар *</Label>
                  <Input
                    name="code"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.code || ""}
                    invalid={
                      validation.touched.code &&
                        validation.errors.code
                        ? true
                        : false
                    }
                  />
                  {validation.touched.code &&
                    validation.errors.code ? (
                    <FormFeedback type="invalid">
                      {validation.errors.code}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Усан цахилгаан станцын нэр *</Label>
                  <Input
                    name="name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name || ""}
                    invalid={
                      validation.touched.name && validation.errors.name
                        ? true
                        : false
                    }
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback type="invalid">
                      {validation.errors.name}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Энергийн эх үүсвэр болох голын нэр  *</Label>
                  <Input
                    name="source_name"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.source_name || ""}
                    invalid={
                      validation.touched.source_name && validation.errors.source_name
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.source_name && validation.errors.source_name ? (
                    <FormFeedback status="invalid">
                      {validation.errors.source_name}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Усан цахилгаан станцын ашиглалтанд оруулсан он *</Label>
                  <Input
                    name="used_date"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.used_date || ""}
                    invalid={
                      validation.touched.used_date && validation.errors.used_date
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.used_date && validation.errors.used_date ? (
                    <FormFeedback status="invalid">
                      {validation.errors.used_date}
                    </FormFeedback>
                  ) : null}
                </div>


                <div className="mb-3">
                  <Label className="text-danger">Усан цахилгаан станцын барьсан байгууллагын нэр  *</Label>
                  <Input
                    name="built_organization_description"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.built_organization_description || ""}
                    invalid={
                      validation.touched.built_organization_description && validation.errors.built_organization_description
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.built_organization_description && validation.errors.built_organization_description ? (
                    <FormFeedback status="invalid">
                      {validation.errors.built_organization_description}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>

              <Col lg={6}>
                <div className="mb-3">
                  <Label className="text-danger">	Хөрөнгө орууллатын төрөл *</Label>
                  <Input
                    name="cmn_invesetment_source"
                    type="select"
                    className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.cmn_invesetment_source || ""}
                    invalid={
                      validation.touched.cmn_invesetment_source &&
                        validation.errors.cmn_invesetment_source
                        ? true
                        : false
                    }
                  >
                    <option disabled value="">Сонгох</option>
                    {commonHydropower?.data?.map((item, index) => (
                      <option value={item?.id}>{item?.name}</option>
                    ))}

                  </Input>
                  {validation.touched.cmn_invesetment_source &&
                    validation.errors.cmn_invesetment_source ? (
                    <FormFeedback type="invalid">
                      {validation.errors.cmn_invesetment_source}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Усан цахилгаан станц голын аль хэсэгт байрлах*</Label>
                  <Input
                    name="source_part"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.source_part || ""}
                    invalid={
                      validation.touched.source_part && validation.errors.source_part
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.source_part && validation.errors.source_part ? (
                    <FormFeedback status="invalid">
                      {validation.errors.source_part}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Төсөвт өртөг *</Label>
                  <Input
                    name="budget_cost"
                    onChange={(e) => {
                      const rawValue = e.target.value.replace(/,/g, '');
                      validation.setFieldValue('budget_cost', rawValue);
                    }}
                    onBlur={validation.handleBlur}
                    value={numberWithCommas(validation.values.budget_cost) || ""}
                    invalid={
                      validation.touched.budget_cost && validation.errors.budget_cost
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.budget_cost && validation.errors.budget_cost ? (
                    <FormFeedback status="invalid">
                      {validation.errors.budget_cost}
                    </FormFeedback>
                  ) : null}
                </div>
                <div className="mb-3">
                  <Label className="text-danger">Усан цахилгаан станцын байршил  *</Label>
                  <Input
                    name="location"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.location || ""}
                    invalid={
                      validation.touched.location && validation.errors.location
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.location && validation.errors.location ? (
                    <FormFeedback status="invalid">
                      {validation.errors.location}
                    </FormFeedback>
                  ) : null}
                </div>

              </Col>
            </Row>
            {!!isEdit ? '' :
              <Row>
                <ShapeUpload selectFiles={setSelectedFiles} onReset={resetFiles} fileType={'point'} />
              </Row>}

          </ModalBody>

          <div className="modal-footer">
            <button type="button" className="btn btn-light" onClick={() => {
              setmodal_backdrop(false);
            }}>Хаах</button>
            <button type="submit" className="btn btn-primary"> Хадгалах </button>
          </div>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default Detail;
